import { Grid, Box, Button, ButtonGroup, Alert } from '@mui/material'
import {
	GridColDef,
	GridRowId,
	GridRowSelectionModel,
	GridValidRowModel,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import { koKR } from '@mui/x-data-grid/locales'
import {
	GridContainer,
	PageContainer,
	PageTop,
	StyledDataGrid,
} from 'components/ApplicationStyles'
import PagePosition from 'components/PagePosition'
import { useEffect, useState } from 'react'
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone'
import DeleteForeverTwoToneIcon from '@mui/icons-material/DeleteForeverTwoTone'
import AddCircleTwoToneIcon from '@mui/icons-material/AddCircleTwoTone'
import { CmmnCodeType } from 'constants/types'
import { valuesInIterator } from 'util/objectUtil'
import {
	apiCmmnCodeByParentId,
	apiCmmnCodeDelete,
	apiCmmnCodeList1depth,
	apiCmmnCodeSave,
} from 'api/api'
import { alertModal, confirmAlert } from 'util/util'
import CheckIcon from '@mui/icons-material/Check'

const cmmnCdColumn: GridColDef[] = [
	{
		field: 'id',
		headerName: 'ID',
		width: 100,
		editable: false,
		type: 'number',
	},
	{
		field: 'cmmnCd',
		headerName: '코드',
		width: 150,
		editable: true,
		type: 'string',
	},
	{
		field: 'cmmnNm',
		headerName: '코드명',
		width: 150,
		editable: true,
		type: 'string',
	},
	{
		field: 'expl',
		headerName: '설명',
		width: 150,
		editable: true,
		type: 'string',
	},
	{
		field: 'seq',
		headerName: '출력순서',
		width: 80,
		editable: true,
		type: 'number',
	},
	{
		field: 'isUse',
		headerName: '사용여부',
		width: 80,
		editable: true,
		type: 'boolean',
	},
]

/**
 * 공통코드 관리 페이지
 * @returns
 */
const CmmnCode = () => {
	const disabledAdd = true
	const disabledDel = true
	const disabledSave = true
	const disabledSearch = false
	const disabledReset = false
	const disabledExcelDownload = true
	const hideAdd = true
	const hideDel = true
	const hideSave = true
	const hideSearch = true
	const hideReset = true
	const hideExcelDownload = true

	const actionAdd = () => {}
	const actionDel = () => {}
	const actionSave = () => {}
	const actionReset = () => {}

	const actionSearch = () => {
		setGrid1IsLoading(true)
		apiCmmnCodeList1depth()
			.then(setCmmnCdListDepth1)
			.finally(() => setGrid1IsLoading(false))
	}

	const gridRef1 = useGridApiRef()
	const gridRef2 = useGridApiRef()
	const gridRef3 = useGridApiRef()
	const [grid1IsLoading, setGrid1IsLoading] = useState(false)
	const [grid2IsLoading, setGrid2IsLoading] = useState(false)
	const [grid3IsLoading, setGrid3IsLoading] = useState(false)
	const [grid1SelectionModel, setGrid1SelectionModel] =
		useState<GridRowSelectionModel>({ type: 'include', ids: new Set() })
	const [grid2SelectionModel, setGrid2SelectionModel] =
		useState<GridRowSelectionModel>({ type: 'include', ids: new Set() })
	const [grid3SelectionModel, setGrid3SelectionModel] =
		useState<GridRowSelectionModel>({ type: 'include', ids: new Set() })

	const gridLoaded = () => {
		setGrid1IsLoading(false)
		setGrid2IsLoading(false)
		setGrid3IsLoading(false)
	}

	/**
	 * 그리드 행 추가
	 * @param gridNumber
	 */
	const addGridRow = (gridNumber: number) => {
		let selectedRows: Map<GridRowId, GridValidRowModel> = new Map()
		if (gridNumber === 1 && gridRef1.current)
			selectedRows = gridRef1.current.getSelectedRows()
		if (gridNumber === 2 && gridRef1.current)
			selectedRows = gridRef1.current.getSelectedRows()
		if (gridNumber === 3 && gridRef2.current)
			selectedRows = gridRef2.current.getSelectedRows()
		const rows = valuesInIterator(selectedRows)
		const newRow = {
			id: Math.random(),
			parentId: gridNumber === 1 ? null : rows[0]?.id,
			cmmnCd: '',
			cmmnNm: '',
			expl: '',
			seq: 0,
			isUse: true,
		}
		let isExistNew = false
		switch (gridNumber) {
			case 1:
				cmmnCdListDepth1.forEach((row) => {
					if (!Number.isInteger(row.id)) {
						isExistNew = true
					}
				})
				if (isExistNew) {
					alertModal('저장 후 추가해주세요.', 'info', () => {})
				} else {
					setCmmnCdListDepth1([...cmmnCdListDepth1, newRow])
					// gridRef1의 신규 추가행에 포커스
					gridRef1.current?.setCellFocus(newRow.id, 'cmmnCd')
					setGrid1SelectionModel({ type: 'include', ids: new Set([newRow.id]) })
					// grid2 , grid3 초기화
					setCmmnCdListDepth2([])
					setCmmnCdListDepth3([])
				}
				break
			case 2:
				cmmnCdListDepth2.forEach((row) => {
					if (!Number.isInteger(row.id)) {
						isExistNew = true
					}
				})
				if (isExistNew) {
					alertModal('저장 후 추가해주세요.', 'info', () => {})
				} else {
					setCmmnCdListDepth2([...cmmnCdListDepth2, newRow])
					// gridRef1의 신규 추가행에 포커스
					gridRef2.current?.setCellFocus(newRow.id, 'cmmnCd')
					setGrid2SelectionModel({ type: 'include', ids: new Set([newRow.id]) })
					// grid3 초기화
					setCmmnCdListDepth3([])
				}
				break
			case 3:
				cmmnCdListDepth3.forEach((row) => {
					if (!Number.isInteger(row.id)) {
						isExistNew = true
					}
				})
				if (isExistNew) {
					alertModal('저장 후 추가해주세요.', 'info', () => {})
				} else {
					setCmmnCdListDepth3([...cmmnCdListDepth3, newRow])
					// gridRef1의 신규 추가행에 포커스
					gridRef3.current?.setCellFocus(newRow.id, 'cmmnCd')
					setGrid3SelectionModel({ type: 'include', ids: new Set([newRow.id]) })
				}
				break
			default:
				break
		}
	}

	/**
	 * 그리드 행 저장
	 * @param gridNumber
	 */
	const saveGridRow = (gridNumber: number) => {
		setGrid1IsLoading(true)
		setGrid2IsLoading(true)
		setGrid3IsLoading(true)
		let selectedRows: Map<GridRowId, GridValidRowModel> = new Map()
		if (gridNumber === 1 && gridRef1.current)
			selectedRows = gridRef1.current.getSelectedRows()
		if (gridNumber === 2 && gridRef2.current)
			selectedRows = gridRef2.current.getSelectedRows()
		if (gridNumber === 3 && gridRef3.current)
			selectedRows = gridRef3.current.getSelectedRows()
		const rows = valuesInIterator(selectedRows)
		// 만약 row.id 값이 소숫점 상태이면 신규로 생성한 row이므로 해당 값은 0 으로 변경 처리
		const rowsWithId = rows.map((row) => {
			if (!Number.isInteger(row.id)) {
				return { ...row, id: 0, level: gridNumber }
			} else {
				return { ...row, level: gridNumber }
			}
		})

		// rowsWithId[0]에 createdAt, updatedAt 필드 제거
		if ('createdAt' in rowsWithId[0]) {
			delete rowsWithId[0].createdAt
		}
		if ('updatedAt' in rowsWithId[0]) {
			delete rowsWithId[0].updatedAt
		}

		if (rowsWithId[0]) {
			apiCmmnCodeSave(rowsWithId[0])
				.then((res) => {
					if (gridNumber === 1) {
						actionSearch()
					} else if (gridNumber === 2) {
						const firstSelectedId = Array.from(grid1SelectionModel.ids)[0] as number
						apiCmmnCodeByParentId(firstSelectedId).then((res) => {
							setCmmnCdListDepth2(res)
						})
					} else if (gridNumber === 3) {
						const firstSelectedId = Array.from(grid2SelectionModel.ids)[0] as number
						apiCmmnCodeByParentId(firstSelectedId).then((res) => {
							setCmmnCdListDepth3(res)
						})
					}
				})
				.finally(() => {
					gridLoaded()
				})
		} else {
			gridLoaded()
		}
	}

	/**
	 * 그리드 행 삭제
	 * @param gridNumber
	 */
	const deleteGridSelectedRows = (gridNumber: number) => {
		setGrid1IsLoading(true)
		setGrid2IsLoading(true)
		setGrid3IsLoading(true)
		let selectedRows: Map<GridRowId, GridValidRowModel> = new Map()
		if (gridNumber === 1 && gridRef1.current)
			selectedRows = gridRef1.current.getSelectedRows()
		if (gridNumber === 2 && gridRef2.current)
			selectedRows = gridRef2.current.getSelectedRows()
		if (gridNumber === 3 && gridRef3.current)
			selectedRows = gridRef3.current.getSelectedRows()
		const rows = valuesInIterator(selectedRows)
		if (rows.length === 0) {
			alertModal('선택된 행이 없습니다.', 'info', () => {})
			return
		}
		if (rows[0]?.id && !Number.isInteger(rows[0].id)) {
			// 신규 행인 경우 그냥 화면에서 제거 (신규행은 소숫점 id)
			if (gridNumber === 1) {
				setCmmnCdListDepth1((prev) => prev.filter((item) => item.id !== rows[0].id))
			} else if (gridNumber === 2) {
				setCmmnCdListDepth2((prev) => prev.filter((item) => item.id !== rows[0].id))
			} else if (gridNumber === 3) {
				setCmmnCdListDepth3((prev) => prev.filter((item) => item.id !== rows[0].id))
			}
			gridLoaded()
		} else {
			confirmAlert(
				'선택된 행을 삭제하시겠습니까?',
				() => {
					switch (gridNumber) {
						case 1:
							apiCmmnCodeByParentId(rows[0].id as number).then((res) => {
								if (res.length > 0) {
									alertModal('하위 데이터가 존재합니다.', 'info', () => {})
									gridLoaded()
									return
								} else {
									apiCmmnCodeDelete(rows[0].id as number)
										.then((res) => {
											if (res.success) {
												actionSearch()
											}
										})
										.finally(() => {
											gridLoaded()
										})
								}
							})
							break
						case 2:
							apiCmmnCodeByParentId(rows[0].id as number).then((res) => {
								if (res.length > 0) {
									alertModal('하위 데이터가 존재합니다.', 'info', () => {})
									gridLoaded()
									return
								} else {
									apiCmmnCodeDelete(rows[0].id as number)
										.then((res) => {
											if (res.success) {
												apiCmmnCodeByParentId(
													Array.from(grid1SelectionModel.ids)[0] as number,
												).then((res) => {
													setCmmnCdListDepth2(res)
												})
											}
										})
										.finally(() => {
											gridLoaded()
										})
								}
							})
							break
						case 3:
							apiCmmnCodeByParentId(rows[0].id as number).then((res) => {
								if (res.length > 0) {
									alertModal('하위 데이터가 존재합니다.', 'info', () => {})
									gridLoaded()
									return
								} else {
									apiCmmnCodeDelete(rows[0].id as number)
										.then((res) => {
											if (res.success) {
												apiCmmnCodeByParentId(
													Array.from(grid2SelectionModel.ids)[0] as number,
												).then((res) => {
													setCmmnCdListDepth3(res)
												})
											}
										})
										.finally(() => {
											gridLoaded()
										})
								}
							})
							break
						default:
							gridLoaded()
							break
					}
				},
				() => {},
			)
		}
	}

	/**
	 * 그리드 선택 변경
	 * @param newSelection
	 * @param gridNumber
	 */
	const onSelectionChange = (
		newSelection: GridRowSelectionModel,
		gridNumber: number,
	) => {
		if (gridNumber === 1) {
			setGrid1SelectionModel(newSelection)
		} else if (gridNumber === 2) {
			setGrid2SelectionModel(newSelection)
		} else if (gridNumber === 3) {
			setGrid3SelectionModel(newSelection)
		}
		const selectedId = Array.from(newSelection.ids)[0]
		// 선택된 행의 id 값으로 하위 그리드 데이터 로드 (소숫점이면 무시)
		if (gridNumber === 1 && Number.isInteger(selectedId)) {
			apiCmmnCodeByParentId(selectedId as number).then(setCmmnCdListDepth2)
		} else if (gridNumber === 2 && Number.isInteger(selectedId)) {
			apiCmmnCodeByParentId(selectedId as number).then(setCmmnCdListDepth3)
		}
	}

	// 그리드 데이터
	const [cmmnCdListDepth1, setCmmnCdListDepth1] = useState<CmmnCodeType[]>([])
	const [cmmnCdListDepth2, setCmmnCdListDepth2] = useState<CmmnCodeType[]>([])
	const [cmmnCdListDepth3, setCmmnCdListDepth3] = useState<CmmnCodeType[]>([])

	useEffect(() => {
		actionSearch()
	}, [])

	return (
		<PageContainer>
			<PageTop>
				<Box>
					<PagePosition
						actionAdd={actionAdd}
						actionDel={actionDel}
						actionSave={actionSave}
						actionSearch={actionSearch}
						actionReset={actionReset}
						actionExcelDownload={() => {}}
						disabledAdd={disabledAdd}
						disabledDel={disabledDel}
						disabledSave={disabledSave}
						disabledSearch={disabledSearch}
						disabledReset={disabledReset}
						disabledExcelDownload={disabledExcelDownload}
						hideAdd={hideAdd}
						hideDel={hideDel}
						hideSave={hideSave}
						hideSearch={hideSearch}
						hideReset={hideReset}
						hideExcelDownload={hideExcelDownload}
					/>
				</Box>
			</PageTop>
			<GridContainer>
				<Grid
					container
					spacing={2}
					sx={{ height: '100%' }}
				>
					<Grid
						size={{ xs: 12, md: 4 }}
						sx={{
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								height: '100%',
							}}
						>
							<Alert
								icon={<CheckIcon fontSize="inherit" />}
								severity="success"
								sx={{ mb: 1.5 }}
							>
								공통코드 DEPTH 1
							</Alert>
							<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
								<StyledDataGrid
									showToolbar
									apiRef={gridRef1}
									columns={cmmnCdColumn}
									rows={cmmnCdListDepth1}
									loading={grid1IsLoading}
									disableMultipleRowSelection
									editMode="row"
									rowSelectionModel={grid1SelectionModel}
									onRowSelectionModelChange={(newRowSelectionModel) => {
										setGrid1SelectionModel(newRowSelectionModel)
										onSelectionChange(newRowSelectionModel, 1)
									}}
									localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
									autosizeOptions={{
										columns: ['cmmnCd', 'cmmnNm', 'expl', 'seq', 'isUse'],
										includeOutliers: true,
										includeHeaders: true,
									}}
									initialState={{
										columns: {
											columnVisibilityModel: {
												crud: false,
												id: false,
											},
										},
									}}
								/>
							</Box>
						</Box>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								mt: 2,
							}}
						>
							<ButtonGroup>
								<Button
									variant="contained"
									color="secondary"
									startIcon={<AddCircleTwoToneIcon />}
									onClick={() => addGridRow(1)}
								>
									추가
								</Button>
								<Button
									variant="contained"
									color="error"
									startIcon={<DeleteForeverTwoToneIcon />}
									disabled={grid1SelectionModel.ids.size === 0}
									onClick={() => deleteGridSelectedRows(1)}
								>
									삭제
								</Button>
							</ButtonGroup>
							<Button
								variant="contained"
								color="primary"
								startIcon={<SaveTwoToneIcon />}
								disabled={grid1SelectionModel.ids.size === 0}
								onClick={() => saveGridRow(1)}
							>
								저장
							</Button>
						</Box>
					</Grid>
					<Grid
						size={{ xs: 12, md: 4 }}
						sx={{
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								height: '100%',
							}}
						>
							<Alert
								icon={<CheckIcon fontSize="inherit" />}
								severity="info"
								sx={{ mb: 1.5 }}
							>
								공통코드 DEPTH 2
							</Alert>
							<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
								<StyledDataGrid
									showToolbar
									apiRef={gridRef2}
									columns={cmmnCdColumn}
									rows={cmmnCdListDepth2}
									loading={grid2IsLoading}
									disableMultipleRowSelection
									editMode="row"
									rowSelectionModel={grid2SelectionModel}
									onRowSelectionModelChange={(newRowSelectionModel) => {
										setGrid2SelectionModel(newRowSelectionModel)
										onSelectionChange(newRowSelectionModel, 2)
									}}
									localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
									autosizeOptions={{
										columns: ['cmmnCd', 'cmmnNm', 'expl', 'seq', 'isUse'],
										includeOutliers: true,
										includeHeaders: true,
									}}
									initialState={{
										columns: {
											columnVisibilityModel: {
												crud: false,
												id: false,
											},
										},
									}}
								/>
							</Box>
						</Box>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								mt: 2,
							}}
						>
							<ButtonGroup>
								<Button
									variant="contained"
									color="secondary"
									startIcon={<AddCircleTwoToneIcon />}
									disabled={!Number.isInteger(Array.from(grid1SelectionModel.ids)[0])}
									onClick={() => addGridRow(2)}
								>
									추가
								</Button>
								<Button
									variant="contained"
									color="error"
									startIcon={<DeleteForeverTwoToneIcon />}
									disabled={grid2SelectionModel.ids.size === 0}
									onClick={() => deleteGridSelectedRows(2)}
								>
									삭제
								</Button>
							</ButtonGroup>
							<Button
								variant="contained"
								color="primary"
								startIcon={<SaveTwoToneIcon />}
								disabled={grid2SelectionModel.ids.size === 0}
								onClick={() => saveGridRow(2)}
							>
								저장
							</Button>
						</Box>
					</Grid>
					<Grid
						size={{ xs: 12, md: 4 }}
						sx={{
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								height: '100%',
							}}
						>
							<Alert
								icon={<CheckIcon fontSize="inherit" />}
								severity="warning"
								sx={{ mb: 1.5 }}
							>
								공통코드 DEPTH 3
							</Alert>
							<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
								<StyledDataGrid
									showToolbar
									apiRef={gridRef3}
									columns={cmmnCdColumn}
									rows={cmmnCdListDepth3}
									loading={grid3IsLoading}
									disableMultipleRowSelection
									editMode="row"
									rowSelectionModel={grid3SelectionModel}
									onRowSelectionModelChange={(newRowSelectionModel) => {
										setGrid3SelectionModel(newRowSelectionModel)
									}}
									localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
									autosizeOptions={{
										columns: ['cmmnCd', 'cmmnNm', 'expl', 'seq', 'isUse'],
										includeOutliers: true,
										includeHeaders: true,
									}}
									initialState={{
										columns: {
											columnVisibilityModel: {
												crud: false,
												id: false,
											},
										},
									}}
								/>
							</Box>
						</Box>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								mt: 2,
							}}
						>
							<ButtonGroup>
								<Button
									variant="contained"
									color="secondary"
									startIcon={<AddCircleTwoToneIcon />}
									disabled={!Number.isInteger(Array.from(grid2SelectionModel.ids)[0])}
									onClick={() => addGridRow(3)}
								>
									추가
								</Button>
								<Button
									variant="contained"
									color="error"
									startIcon={<DeleteForeverTwoToneIcon />}
									disabled={grid3SelectionModel.ids.size === 0}
									onClick={() => deleteGridSelectedRows(3)}
								>
									삭제
								</Button>
							</ButtonGroup>
							<Button
								variant="contained"
								color="primary"
								startIcon={<SaveTwoToneIcon />}
								disabled={grid3SelectionModel.ids.size === 0}
								onClick={() => saveGridRow(3)}
							>
								저장
							</Button>
						</Box>
					</Grid>
				</Grid>
			</GridContainer>
		</PageContainer>
	)
}

export default CmmnCode
